import React from 'react';
import { LogOut, ShieldAlert } from 'lucide-react';
import { isTabImpersonating } from '../../../shared/services/token';

/**
 * Shown across the top whenever a super admin is signed in as a customer.
 *
 * Two jobs, both important. It makes an impersonated session impossible to
 * mistake for your own — otherwise you could act as someone else without
 * realising — and it holds the only route back, since signing in as a company
 * replaces your platform session.
 */
const LABEL_KEY = 'recruit_impersonating';

/**
 * True only when the *current token itself* says it is an impersonation.
 *
 * Deliberately not a localStorage flag: a stale flag would show this banner to a
 * real company admin who signs in on the same browser. The `act` claim is put
 * there by the server when it mints the token, so it cannot be present on an
 * ordinary login however the browser got into this state.
 */
export function isImpersonating() {
  return isTabImpersonating();
}


export function returnToPlatform() {
  // The platform session is untouched in the tab that opened this one, so
  // leaving is just closing this tab.
  window.close();
}

export default function ImpersonationBanner() {
  if (!isImpersonating()) return null;
  let company = 'a customer account';
  try { company = sessionStorage.getItem(LABEL_KEY) || company; } catch { /* label is cosmetic */ }

  return (
    <div
      role="status"
      style={{
        position: 'sticky', top: 0, zIndex: 200,
        marginLeft: 'var(--sidebar-width, 240px)',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        gap: 16, flexWrap: 'wrap',
        padding: '9px 22px',
        background: '#fff4e2',
        borderBottom: '1px solid rgba(245, 158, 11, 0.5)',
        color: '#8a5a08',
        fontSize: 13,
      }}
    >
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, fontWeight: 600 }}>
        <ShieldAlert size={15} />
        Signed in as <strong>{company}</strong> — you are not on your own account.
      </span>
      <button
        type="button"
        onClick={returnToPlatform}
        style={{
          display: 'inline-flex', alignItems: 'center', gap: 6,
          padding: '6px 13px', fontSize: 12.5, fontWeight: 600,
          borderRadius: 6, cursor: 'pointer',
          background: '#8a5a08', color: '#fff', border: 'none',
        }}
      >
        <LogOut size={13} /> Close this tab
      </button>
    </div>
  );
}
